"use strict";
/*
author:gaokaizhi
date:2017-07-19
 */
angular.module("planCommandMonitorManuscriptAnalysisAddEditcustomManuscriptPropModule", ["addCustomManuscriptPropModel"])
    .controller("addEditcustomManuscriptPropCtrl", ["$scope", "$location", "$modal", "modalDialog", "trsHttpService", "$state", "$validation","$stateParams",
        function($scope, $location, $modal, modalDialog, trsHttpService, $state, $validation,$stateParams) {
            initStatus();
            initData();
            /**
             * [initData description:初始化数据]            
             */
            function initData() {
                if ($stateParams.id) {
                    editeTitle();
                };
            };
            /**
             * [editeTitle description] 编辑传播力标题列表 
             * @return {[type]} [description]
             */
            function editeTitle() {
                $scope.title_id = $stateParams.id;
                var params = {
                    modalname: "manuScriptsFuncAdd",
                    method: "getGroupsByTitleId",
                    methodname: "queryDataFromBigScreen",
                    serviceid: "mlf_bigdatascreen",
                    manuscripts_title_id: $stateParams.id
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.list = data.mapResult.content.records;
                    $scope.save_title = data.mapResult.content.title;
                    jQuery.each($scope.list, function(index, val) {
                        if (val.sortNum == 0) {
                            val.sortNum = "";
                        }
                    });
                });
            };
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {               
                //页面标题双向绑定的数据
                $scope.save_title = "";
                //存放已选稿件数据的数组
                $scope.list = [];
                //需要编辑的标题ID
                $scope.title_id = "";
            };
            /**
             * [addCustomManuscriptProp description:稿件添加弹出窗口]                     
             */
            $scope.addCustomManuscriptProp = function() {
                var modalInstance = $modal.open({
                    templateUrl: "./planningResource/commandMonitor/manuscriptAnalysis/customManuscriptProp/addEditCustomManuscriptProp/addCustomManuscriptPropModel/addCustomManuscriptPropModel.html",                                    
                    windowClass: "plan-commandMonitor-addManuscriptProp",
                    backdrop: true,
                    controller: "addCustomManuscriptPropModelCtrl",
                    resolve: {
                        existList: function() {
                            return $scope.list;
                        }

                    }
                });
                modalInstance.result.then(function(data) {
                    if (angular.isFunction(success)) {
                        success(data);
                    }
                });
            };
            /**
             * [success description:稿件添加弹出窗口的回调函数]
             * @param  [{type}] data [稿件添加弹出窗口传回的被选中稿件数据]             
             */
            function success(data) {
                $scope.list = data;
                jQuery.each($scope.list, function(index, val) {
                    if (val.sortNum == 0) {
                        val.sortNum = "";
                    };
                });
            };
            /**
             * [deleteItm description:删除稿件列表稿件]
             * @param  "" guid [需要被删除稿件的zbGuid]             
             */
            $scope.deleteItm = function(guid) {
                modalDialog.confirmModal("删除提示", "是否确定删除？",function() {
                    for (var i = 0; i < $scope.list.length; i++) {
                        if ($scope.list[i].zbGuid == guid) {
                            $scope.list.splice(i, 1);
                            break;
                        };
                    };
                });
            };
             /**
             * [saveAndUpdataArt description:自定义稿件传播力提交保存]               
             */
            $scope.saveAndUpdataArt = function() {
                $validation.validate($scope.add_edit)
                    .success(function() {
                        var h = "";
                        var params = {
                            modalname: "manuScriptsFuncAdd",
                            method: "saveArticles",
                            methodname: "queryDataFromBigScreen",
                            serviceid: "mlf_bigdatascreen",
                            save_title: $scope.save_title,
                            save_content: "",
                            manuscripts_title_id: $scope.title_id
                        };
                        if ($scope.list.length == 0) {
                            modalDialog.alertType("提交失败", "请添加稿件", "error", false);
                            return;
                        };
                        for (var i = 0; i < $scope.list.length; i++) {
                            h += $scope.list[i].zbGuid;
                            h += ",";
                            if ($scope.list[i].sortNum == "") {
                                $scope.list[i].sortNum = 0;
                            };
                            h += $scope.list[i].sortNum;
                            h += "$";
                        };
                        params.save_content = h.slice(0, h.length - 1);
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                            if (data.mapResult.status = "success") {
                                if ($stateParams.id) {
                                    modalDialog.confirmModal("编辑自定义稿件传播力", "编辑成功", function() { $state.go("front.planningresource.commandMonitor.manuscriptanalysis.custommanuscriptprop"); })
                                } else {
                                    modalDialog.confirmModal("添加自定义稿件传播力", "添加成功", function() { $state.go("front.planningresource.commandMonitor.manuscriptanalysis.custommanuscriptprop"); })
                                }
                            }
                        });
                    })
                    .error(function(msg) {
                        modalDialog.alertType("提交失败", "请检查填写项", "error", false);
                    });
            };
        }
    ]);